import { windowResizeAxisX } from './utils.js';

(function() {
    var swiperInit = function() {
        if(document.querySelector('[data-load-swiper]')) {
			import('./plugins/swiper/js/swiper.min').then((Swiper) => {
				var setActiveCircle = function(pagination, activeEl) {
					if (pagination) {
						setTimeout(function() { // нужен чтобы можно было от позиционаривать круглыжок по активному классу так как не сразу добавляется активный класс
							var activePagination = pagination.querySelector('.swiper-pagination-bullet-active');
							
							if (activePagination) {
								activeEl.style.transform = 'translateX(' + activePagination.offsetLeft + 'px)';
							}
						}, 50);
					}
				};

				(function(){
					var blueSlider = document.querySelector('.js-blue-slider');

					if (blueSlider) {
						var paginationEl;
						var paginationActiveCircle;
						var pagination  = blueSlider.querySelector('.js-slider-pagination-circle');

						if (pagination) {
							paginationEl  = pagination.querySelector('.js-slider-pagination-circle__items');
							paginationActiveCircle = pagination.querySelector('.js-slider-pagination-circle__active');
						}

						var blueSliderEl = blueSlider.querySelector('.swiper-container');
						var navigationNext = blueSlider.querySelector('.js-slider-navigation_next');

						new Swiper.default(blueSliderEl, {
							speed: 800,
							loop: true,
							effect: 'fade',
							pagination: {
								el: paginationEl,
								clickable: true,
							},
							navigation: {
								// prevEl: '.js-slider-navigation_prev',
								nextEl: navigationNext,
							},
							breakpoints: {
								768: {
									autoHeight: true
								}
							},
							on: {
								slideChange: function() {
									if (pagination) {
										setActiveCircle(pagination, paginationActiveCircle);
									}
								}
							}
						});

						windowResizeAxisX(function(){
							if (pagination) {
								setActiveCircle(pagination, paginationActiveCircle);
							}
						});
					}
				})();

				(function(){
					if (window.matchMedia("(max-width: 768px)").matches) {
						var doctorsSlider = document.querySelector('.js-doctors-slider');

						if (doctorsSlider) {
							var doctorsSliderEl = doctorsSlider.querySelector('.swiper-container');

							new Swiper.default(doctorsSliderEl, {
								slidesPerView: 'auto',
								spaceBetween: 24,
								freeMode: true
							});
						}
					}
				})();

				(function(){
					if (window.matchMedia("(max-width: 768px)").matches) {
						var certificatesSlider = document.querySelector('.js-certificates-slider');

						if (certificatesSlider) {
							var certificatesSliderEl = certificatesSlider.querySelector('.swiper-container');

							new Swiper.default(certificatesSliderEl, {
								slidesPerView: 'auto',
								spaceBetween: 24,
								freeMode: true
							});
						}
					}
				})();
				
				(function(){
					if (window.matchMedia("(max-width: 768px)").matches) {
						var advantagesSlider = document.querySelector('.js-advantages-slider');

						if (advantagesSlider) {
							var advantagesSliderEl = advantagesSlider.querySelector('.swiper-container');

							new Swiper.default(advantagesSliderEl, {
								slidesPerView: 'auto',
								spaceBetween: 32,
								freeMode: true
							});
						}
					}
				})();

				(function(){
					var reviewsSlider = document.querySelector('.js-reviews-slider');

					if (reviewsSlider) {
						var paginationEl;
						var paginationActiveCircle;
						var pagination = reviewsSlider.querySelector('.js-slider-pagination-nums');
						
						if (pagination) {
							paginationEl = pagination.querySelector('.js-slider-pagination-nums__items');
							paginationActiveCircle = pagination.querySelector('.js-slider-pagination-nums__active');
						}

						var reviewsSliderEl = reviewsSlider.querySelector('.swiper-container');
						
						new Swiper.default(reviewsSliderEl, {
							speed: 800,
							slidesPerView: 3,
							slidesPerGroup: 3,
							slidesPerColumn: 2,
							pagination: {
								el: paginationEl,
								clickable: true,
								renderBullet: function (index, className) {
									return '<span class="' + className + '">' + (index + 1) + '</span>';
								},
							},
							breakpoints: {
								1200: {
									slidesPerView: 2,
									slidesPerGroup: 2,
									pagination: {
										dynamicBullets: true,
										dynamicMainBullets: 1,
									}
								},
								768: {
									slidesPerView: 1,
									slidesPerGroup: 1,
									spaceBetween: 15,
									pagination: {
										dynamicBullets: true,
										dynamicMainBullets: 1,
									}
								}
							},
							on: {
								init: function () {
									var reviewTexts = document.querySelectorAll('.js-reviews-block__text');

									if (reviewTexts.length) {
										[].forEach.call(reviewTexts, function(reviewText) {
											var maxHeight = parseInt(window.getComputedStyle(reviewText, null).getPropertyValue('max-height'), 10); // получаем дефолтный max-height
											var lineClamp = window.getComputedStyle(reviewText, null).getPropertyValue('-webkit-line-clamp'); // получаем дефолтный line-clamp

											reviewText.style.maxHeight = 'none'; // сбрасываем max height для получения высоты контента
											reviewText.style.WebkitLineClamp = 'initial'; // сбрасываем line clamp для получения высоты контента

											var height = reviewText.offsetHeight;

											reviewText.style.maxHeight = ''; // устанавливаем обратно max-height
											reviewText.style.WebkitLineClamp = ''; // устанавливаем обратно line-clamp

											if (height > maxHeight) {
												var btn = reviewText.nextElementSibling;
												
												if (btn && btn.classList.contains('js-reviews-block__read-more')) {
													btn.style.display = 'inline-block';

													btn.addEventListener('click', function(){
														reviewText.classList.toggle('active');
														btn.text = (btn.text == 'Скрыть') ? 'Отзыв полностью' : 'Скрыть';
													});
												}
											}
										});
									}

									if (pagination) {
										setActiveCircle(pagination, paginationActiveCircle);
									}
								},
								slideChange: function() {
									setActiveCircle(pagination, paginationActiveCircle);
								},
								breakpoint: function() { // hack для dynamicBullets так как пагинация увеличивается в мобилке see https://github.com/nolimits4web/swiper/issues/3727
									if (pagination) {
										if (this.params.pagination.dynamicBullets) {
											this.pagination.init();
										} else {
											var _this = this;
											setTimeout(function () {
												_this.pagination.el.style.width = '100%'
												_this.pagination.el.classList.remove('swiper-pagination-bullets-dynamic');
											});
										}
									}
								}
							}
						});

						windowResizeAxisX(function(){
							if (pagination) {
								setActiveCircle(pagination, paginationActiveCircle);
							}
						});
					}
				})();

				(function(){
					var contactsSlider = document.querySelector('.js-contacts-slider');

					if (contactsSlider) {	
						var paginationEl;
						var paginationActiveCircle;
						var pagination = contactsSlider.querySelector('.js-slider-pagination-circle');

						if (pagination) {
							paginationEl = pagination.querySelector('.js-slider-pagination-circle__items');
							paginationActiveCircle = pagination.querySelector('.js-slider-pagination-circle__active');
						}
						
						var contactsSliderEl = contactsSlider.querySelector('.swiper-container');
						
						new Swiper.default(contactsSliderEl, {
							speed: 800,
							effect: 'fade',
							slidesPerView: 1,
							pagination: {
								el: paginationEl,
								clickable: true,
							},
							on: {
								slideChange: function() {
									if (pagination) {
										setActiveCircle(pagination, paginationActiveCircle);
									}
								}
							}
						});

						windowResizeAxisX(function(){
							if (pagination) {
								setActiveCircle(pagination, paginationActiveCircle);
							}
						});
					}
				})();
				
				(function(){
					var  bannerSlider = document.querySelector('.js-banner-slider');

					if (bannerSlider) {	
						var paginationEl;
						var paginationActiveCircle;
						var pagination = bannerSlider.querySelector('.js-slider-pagination-circle');
						
						if (pagination) {
							paginationEl = pagination.querySelector('.js-slider-pagination-circle__items');
							paginationActiveCircle = pagination.querySelector('.js-slider-pagination-circle__active');
						}
						
						var bannerSliderEl = bannerSlider.querySelector('.swiper-container');
						var navigationPrev = bannerSlider.querySelector('.js-slider-navigation_prev');
						var navigationNext = bannerSlider.querySelector('.js-slider-navigation_next');

						new Swiper.default(bannerSliderEl, {
							loop: true,
							speed: 800,
							effect: 'fade',
							slidesPerView: 1,
							pagination: {
								el: paginationEl,
								clickable: true,
							},
							navigation: {
								prevEl: navigationPrev,
								nextEl: navigationNext,
							},
							on: {
								slideChange: function() {
									if (pagination) {
										setActiveCircle(pagination, paginationActiveCircle);
									}
								}
							}
						});

						windowResizeAxisX(function(){
							if (pagination) {
								setActiveCircle(pagination, paginationActiveCircle);
							}
						});
					}
				})();

				(function(){
					var  portfolioSlider = document.querySelector('.js-portfolio-slider');

					if (portfolioSlider) {
						var paginationEl;
						var paginationActiveCircle;
						var pagination = portfolioSlider.querySelector('.js-slider-pagination-circle');
						
						if (pagination) {
							paginationEl = pagination.querySelector('.js-slider-pagination-circle__items');
							paginationActiveCircle = pagination.querySelector('.js-slider-pagination-circle__active');
						}
						
						var portfolioSliderEl = portfolioSlider.querySelector('.swiper-container');
						var navigationPrev = portfolioSlider.querySelector('.js-slider-navigation-gray_prev');
						var navigationNext = portfolioSlider.querySelector('.js-slider-navigation-gray_next');

						new Swiper.default(portfolioSliderEl, {
							speed: 800,
							loop: true,
							effect: 'fade',
							fadeEffect: {
								crossFade: true
							},
							slidesPerView: 1,
							pagination: {
								el: paginationEl,
								clickable: true,
							},
							navigation: {
								prevEl: navigationPrev,
								nextEl: navigationNext,
							},
							on: {
								slideChange: function() {
									if (pagination) {
										setActiveCircle(pagination, paginationActiveCircle);
									}
								}
							}
						});

						var centerArrowSlider = function name(params) {
							var maxHeight = 0;
							var navigation = document.querySelector('.js-portfolio-slider__navigations');
							var photoElements = document.querySelectorAll('.js-portfolio-slider__get-max-height');

							if (navigation && photoElements) {
								[].forEach.call(photoElements, function(item){
									var height = item.offsetHeight;

									if(height > maxHeight){
										maxHeight = height;
									}
								});

								navigation.style.top = 'auto';
								navigation.style.bottom = (maxHeight / 2) + 'px';
							}
						};

						centerArrowSlider();

						windowResizeAxisX(function(){
							if (pagination) {
								setActiveCircle(pagination, paginationActiveCircle);
							}

							centerArrowSlider();
						});
					}
				})();
			});
		}
	};

	swiperInit();
})();